import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Page from './Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    clearPostLoginReturn,
    rememberPostLoginReturn,
} from '../../utils/postLoginReturn';

const PrivateRoute = ({
    // component: Component,
    title,
    auth: { isAuthenticated, loading },
    children,
}) => {
    const location = useLocation();
    const returnTo = `${location.pathname}${location.search || ''}`;
    const searchParams = new URLSearchParams(location.search || '');
    if (isAuthenticated) {
        clearPostLoginReturn();
    } else if (
        searchParams.get('eventID') ||
        searchParams.get('open') ||
        searchParams.get('hat')
    ) {
        rememberPostLoginReturn(returnTo);
    }
    return !isAuthenticated && !loading ? (
        <Navigate
            to={{ pathname: '/login', search: location.search || '' }}
            state={{ from: returnTo }}
            replace
        />
    ) : (
        <Page title={title}>
            {children}
            {/* <Component /> */}
        </Page>
    );
};

PrivateRoute.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
